import {Alert} from 'components';
import {Platform} from 'react-native';
import {apiAuth, navigate} from 'services';
import {getUuid} from 'utils';
export const doUploadFileSignature = async (p: {
  link: string;
  setLoading: (t: boolean) => void;
  I18nState: 'en' | 'vi';
}) => {
  try {
    const bb = await fetch(p.link);
    const blob = await bb.blob();
    const id = getUuid();
    p.setLoading(true);
    const formdata = new FormData();
    const file = new File([blob], `${id}.png`);
    formdata.append('file', file);
    const res = await apiAuth.createEsignature(formdata);
    // const phone = await getStoreData('phone');
    if (res.status == 200 && !!res.data.otpInfo) {
      navigate('OtpRequestModal', {
        data: {
          requestOnSendOtp: res.data.otpInfo,
          flowApp: 'CreateEsignature',
          // phone,
        },
      });
      return;
    }
    Alert.showError({
      content: p.I18nState == 'vi' ? res.message : res.messageEn,
      multilanguage: false,
    });
    return;
  } catch (error: any) {
    Alert.showError({
      content: p.I18nState == 'vi' ? error.message : error.messageEn,
      multilanguage: false,
    });
    p.setLoading(false);
    return;
  } finally {
    p.setLoading(false);
  }
};

export const doUploadFileEsignatureRisk = async (p: {
  link: string;
  setLoading: (t: boolean) => void;
  I18nState: 'en' | 'vi';
}) => {
  try {
    const id = getUuid();
    p.setLoading(true);
    const formdata = new FormData();
    const file = {
      uri: Platform.OS !== 'android' ? p.link.replace('file://', '') : p.link,
      name: `${id}.png`,
      filename: `${id}.png`,
      type: 'image/png',
    };
    formdata.append('file', file);
    const res = await apiAuth.createEsignatureRisk(formdata);
    if (res.status == 200 && !!res.data.otpInfo) {
      navigate('OtpRequestModal', {
        data: {
          requestOnSendOtp: res.data.otpInfo,
          flowApp: 'CreateEsignatureRisk',
        },
      });
      return;
    }
    Alert.showError({
      content: p.I18nState == 'vi' ? res.message : res.messageEn,
      multilanguage: false,
    });
    return;
  } catch (error: any) {
    Alert.showError({
      content: p.I18nState == 'vi' ? error.message : error.messageEn,
      multilanguage: false,
    });
  } finally {
    p.setLoading(false);
  }
};
